import { buttonClasses } from '@mui/material';

export const DELEGATE_VALUE_OFFSET = 0;

export const CREATED_BY_VALUE_MARGIN_LEFT = 16;

export const UNASSIGNED_ASSIGNEE_START_ICON_MARGIN_LEFT = 0;

export const unassignedAssigneeSelectButtonSx = {
  [`& .${buttonClasses.startIcon}`]: {
    marginLeft: UNASSIGNED_ASSIGNEE_START_ICON_MARGIN_LEFT,
  },
};
